module.exports = __webpack_public_path__ + "static/media/dsjyLogo.c66ed51c.png";